var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5568 0.13544L0.284077 8.13544C0.10735 8.25997 -0.000867488 8.46236 5.23899e-06 8.66669V23.3333C4.16026e-05 23.6824 0.346478 24 0.727278 24H8.36364C8.74444 24 9.09088 23.6824 9.09091 23.3333V15.3334H14.9091V23.3333C14.9091 23.6824 15.2556 24 15.6364 24H23.2727C23.6535 24 24 23.6824 24 23.3333V8.66669C24 8.46236 23.8927 8.25997 23.7159 8.13544L12.4432 0.13544C12.1119 -0.0543595 11.8265 -0.0356929 11.5568 0.13544ZM12 1.50004L22.5455 8.9896V22.6667H16.3636V14.6667C16.3636 14.3176 16.0172 14.0001 15.6364 14H8.36364C7.98284 14.0001 7.6364 14.3176 7.63637 14.6667V22.6667H1.45455V8.9896L12 1.50004Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.1191ee5db7c35d24b94b66cdfca17070.svg";
export { ForwardRef as ReactComponent };